import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Interfaces ---
import type { IVersion, IVersions } from '@interfaces/version';

export interface IVersionsState extends IVersions {}

export const INITIAL_STATE: IVersionsState = {
	metadata: {
		page: 0,
		pageLimit: 0,
		count: 0,
	},
	result: [],
};

@Injectable({
	providedIn: 'root',
})
export class VersionsStore {
	private _versionsState = new BehaviorSubject<IVersionsState>(INITIAL_STATE);
	readonly versionsState$ = this._versionsState.asObservable();

	constructor() {}

	updateVersions(versions: IVersionsState) {
		const state = this._versionsState.value;

		const data = {
			...state,
			...versions,
		};

		this._versionsState.next(data);

		return this._versionsState.asObservable();
	}

	updateVersion(version: IVersion) {
		const state = this._versionsState.value;

		const versionIndex = state.result.findIndex(({ id }) => id === version.id);

		if (versionIndex >= 0) {
			state.result[versionIndex] = {
				...state.result[versionIndex],
				...version,
			};
		} else {
			state.result.push(version);
		}

		const data = state;

		this._versionsState.next(data);

		return this._versionsState.asObservable();
	}

	deleteVersion(version: IVersion) {
		const state = this._versionsState.value;

		const versionIndex = state.result.findIndex(({ id }) => id === version.id);

		state.result.splice(versionIndex, 1);

		const data = state;

		this._versionsState.next(data);

		return this._versionsState.asObservable();
	}
}
